<template>
  <div class="el-core__header__right coreRight">
    <div class="emd-drawer _right">
      <div
        class="emd-drawer__trigger coreRight-trigger"
        :class="{ _open: isOpen }"
      >
        <button
          class="emd-action-button"
          @click="toggleDrawerMenu"
        >
          <i class="uil uil-ellipsis-v emd-action-button__icon"></i>
        </button>
      </div>
      <div
        class="coreRight-content"
        :class="{ _open: isOpen, 'coreRight-content__open': isOpen }"
      >
        <emd-dropdown v-if="canShowPix || canShowAppsList">
          <template v-slot:trigger>
            <div>
              <ul>
                <li
                  v-for="item in popoverItems"
                  :key="item.title"
                >
                  <button
                    class="coreRight-items"
                    @click="item.action"
                  >
                    {{ item.title }}
                  </button>
                </li>
              </ul>
            </div>
          </template>
        </emd-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { EmdDropdown } from 'emerald-vue/src/components'

import shopEnabled from '@/actions-permission/shop.permissions'

import { ITEMS_POPOVER } from './app-core-popover.enum'

export default {
  name: 'AppCoreHeaderRight',
  components: {
    EmdDropdown
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    merchant: {
      type: Object,
      default: null
    },
    account: {
      type: Object,
      default: null
    },
    profile: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters([
      'userRole',
      'userType',
      'isEmployee',
      'hasShopUnavailable',
      'componentIsEnabled',
      'permissionIsEnabled'
    ]),
    canShowHub () {
      return (
        this.componentIsEnabled('apps', 'hub') &&
        this.permissionIsEnabled('links.hub:get')
      )
    },
    canShowPix () {
      return (
        this.componentIsEnabled('global', 'pix') &&
        this.permissionIsEnabled('links.pix:get')
      )
    },
    canShowAppsList () {
      return (
        this.canShowHub ||
        shopEnabled(
          this.permissionIsEnabled,
          this.componentIsEnabled,
          this.hasShopUnavailable
        )
      )
    },
    popoverItems () {
      return ITEMS_POPOVER(this.isEmployee, {
        merchantId: this.merchant.id,
        toggleGlobalLoading: this.toggleGlobalLoading,
        DELETE_AUTHORIZATION: this.DELETE_AUTHORIZATION
      }).map(item => ({
        ...item,
        title: this.$t(item.title)
      }))
    }
  },
  methods: {
    ...mapActions(['toggleGlobalLoading', 'DELETE_AUTHORIZATION']),
    toggleDrawerMenu () {
      this.$emit('drawerMenuClicked')
    }
  }
}
</script>

<style scoped>
.coreRight-trigger {
  display: none;
}

.coreRight-items {
  height: 40px;
  display: flex;
  align-items: center;
  border: none;
  background-color: transparent;
  cursor: pointer;
  font-size: 14px;
  width: 100%;
  color: var(--gray-600-birdperson);
  font-weight: bold;
}

.coreRight-content {
  display: none;
}

@media only screen and (max-width: 768px) {
  .coreRight-trigger {
    display: flex !important;
  }

  .coreRight-content__open {
    background: var(--color-white);
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 64px);
    position: absolute;
    right: 0;
    top: 64px;
    width: 100%;
    z-index: 0;
    padding: 12px 24px;
  }
}
</style>
